import { AddPlusButton } from '@components/core-ui/buttons/AddPlusButton';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { OrganizationCard } from './components/OrganizationCard';

export function OrganizationCards() {
  const { openModal } = useModalContext();
  const { me } = useAuthContext();

  const handleCreateOrganizationModalOpen = () => {
    openModal(ModalNamesEnum.NewOrganizationModal);
  };

  return (
    <div className="mt-5">
      <ul className="list flex flex-wrap gap-5">
        {me.organizations.map((organization) => (
          <OrganizationCard key={organization.id} organization={organization} />
        ))}
        {me.canCreateOrganizations === false ? null : <AddPlusButton onClick={handleCreateOrganizationModalOpen} />}
      </ul>
    </div>
  );
}
